import { z } from "zod";

export const EventCalendarLayerSchema = z.enum(["events", "shows"]);
export type EventCalendarLayerDTO = z.infer<typeof EventCalendarLayerSchema>;

export const EventCalendarItemSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  layer: EventCalendarLayerSchema,
  title: z.string(),
  status: z.enum(["draft", "confirmed", "completed", "cancelled"]),
  /** yyyy-MM-dd */
  date: z.string(),
  startTime: z.string().nullable().optional(),
  endTime: z.string().nullable().optional(),
  categoryId: z.string().nullable(),
  categoryName: z.string().nullable(),
  locationText: z.string().nullable(),
  roomName: z.string().nullable(),
  showSortOrder: z.number().int().nullable().optional(),
});
export type EventCalendarItemDTO = z.infer<typeof EventCalendarItemSchema>;

export const EventCalendarTbdItemSchema = z.object({
  eventId: z.string(),
  title: z.string(),
  status: z.enum(["draft", "confirmed", "completed", "cancelled"]),
  categoryId: z.string().nullable(),
  categoryName: z.string().nullable(),
  locationText: z.string().nullable(),
});
export type EventCalendarTbdItemDTO = z.infer<typeof EventCalendarTbdItemSchema>;

export const EventCalendarQuerySchema = z.object({
  start: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  end: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  layer: EventCalendarLayerSchema.default("events"),
  status: z.string().optional(),
  categoryId: z.string().optional(),
  title: z.string().optional(),
});
export type EventCalendarQueryDTO = z.infer<typeof EventCalendarQuerySchema>;

export const EventCalendarResponseSchema = z.object({
  items: z.array(EventCalendarItemSchema),
  tbdEvents: z.array(EventCalendarTbdItemSchema),
});
export type EventCalendarResponseDTO = z.infer<
  typeof EventCalendarResponseSchema
>;
